import { passRewardForDelivery } from '../../../../domain/economy/deliveryPassReward';
import type { GiantId } from '../../../../domain/ids/ids';
import { useAppStore } from '../../../store/appStore';
import { DeliveryPopup } from '../../components/atomic/dialog/delivery_popups/DeliveryPopup';
import { getDeliveryPopupTransformOrigin } from '../../components/atomic/dialog/delivery_popups/deliveryPopupLayout';
import { MAP_POPUP_COUNTER_SCALE } from '../lands/landPositions';
import {
  DELIVERY_POPUP_PLACEMENTS,
  getDeliveryPopupPlacement,
} from './deliveryPopupPositions';

/** Show every giant popup so map positions can be edited. */
const PREVIEW_ALL_DELIVERY_POPUPS = false;
const PREVIEW_URGENCY = 'regular' as const;
const PREVIEW_WAITING_DAY = 1;

export type MapDeliveryPopupsProps = {
  onTakeDelivery?: (giantId: GiantId, orderIndex: number) => void;
};

export function MapDeliveryPopups({ onTakeDelivery }: MapDeliveryPopupsProps) {
  const deliveryPool = useAppStore((s) => s.playerEconomy.deliveryPool);

  if (PREVIEW_ALL_DELIVERY_POPUPS) {
    const passReward = passRewardForDelivery(PREVIEW_URGENCY, PREVIEW_WAITING_DAY);

    return (
      <>
        {DELIVERY_POPUP_PLACEMENTS.map((placement) => {
          const tail = placement.tail ?? 'down';

          return (
            <DeliveryPopup
              key={placement.giantId}
              urgency={PREVIEW_URGENCY}
              waitingDay={PREVIEW_WAITING_DAY}
              passReward={passReward}
              tail={tail}
              style={{
                left: placement.left,
                top: placement.top,
                transform: `scale(${MAP_POPUP_COUNTER_SCALE})`,
                transformOrigin: getDeliveryPopupTransformOrigin(tail),
              }}
            />
          );
        })}
      </>
    );
  }

  const activeEntries = deliveryPool.filter(
    (entry) => entry.status === 'active' && entry.fromHistoryReplay !== true,
  );

  return (
    <>
      {activeEntries.map((entry) => {
        const placement = getDeliveryPopupPlacement(entry.giantId);
        if (placement == null) {
          return null;
        }

        const passReward = passRewardForDelivery(entry.urgency, entry.waitingDay);
        const tail = placement.tail ?? 'down';

        return (
          <DeliveryPopup
            key={entry.deliveryId}
            urgency={entry.urgency}
            waitingDay={entry.waitingDay}
            passReward={passReward}
            tail={tail}
            style={{
              left: placement.left,
              top: placement.top,
              transform: `scale(${MAP_POPUP_COUNTER_SCALE})`,
              transformOrigin: getDeliveryPopupTransformOrigin(tail),
            }}
            onTakeOrder={() => {
              onTakeDelivery?.(entry.giantId, entry.orderIndex);
            }}
          />
        );
      })}
    </>
  );
}
